import Router from 'vue-router'
import Login from '@/components/Login'
import Main from '@/components/Main'
import List from '@/components/List'
import Add from '@/components/add/addForm'
import Edit from '@/components/edit/editForm'
import Conclusion from '@/components/conclusion/conclusionForm'
import GroupConclusion from '@/components/group_conclusion/groupConclusionForm'
import Warrant from '@/components/warrant/warrantForm'
import WarrantGroup from '@/components/warrant_group/WarrantGroupForm'
import NotFound from '@/components/NotFound'
import Reg from '@/components/reg/Reg'
import ListDrafts from '@/components/ListDrafts'
import ListStates from '@/components/ListStates'
import ListDecisions from '@/components/ListDecisions'
import ListSupervisory from '@/components/ListSupervisory'

import Reports from '@/components/reports/Reports'
import Monitoring from '@/components/reports/Monitoring'
import MonitoringRlh from '@/components/reports/MonitoringRlh'
import ConclusionReport from '@/components/reports/Conclusion'
import Mzl from '@/components/reports/Mzl'
import NpaMzl from '@/components/reports/NpaMzl'
import WarrantsCount from '@/components/reports/WarrantsCount'
import Stat from '@/components/reports/Stat'
import StatLpo from '@/components/reports/StatLpo'

import MonitoringV2 from '@/components/reports/MonitoringV2'
import MonitoringRlhV2 from '@/components/reports/MonitoringRlhV2'
import ConclusionReportV2 from '@/components/reports/ConclusionV2'
import MzlV2 from '@/components/reports/MzlV2'

import Supervision from '@/components/supervision/supervisionForm'

import TerritoryCatalog from '@/components/catalog/TerritoryCatalog'

import auth from '../auth'

import { EventBus } from '../lib/EventBus'

const router = new Router({
	mode: 'hash',
	routes: [
		{
			path: '/',
			redirect: '/main'
		},
		{
			path: '/main',
			component: Main,
			children: [
				{
					path: '/',
					name: 'list',
					component: List,
					beforeEnter: (to, from, next) => {
						if (from.name === 'edit' || from.name === 'conclusion' || from.name === 'warrant') {
							to.params.id = from.params.id
						}
						else {
							to.params.id = null
						}
						next()
					}
				},
				{
					path: 'drafts',
					name: 'drafts',
					component: ListDrafts
				},
				{
					path: 'states',
					name: 'states',
					component: ListStates
				},
				{
					path: 'decisions',
					name: 'decisions',
					component: ListDecisions
				},
				{
					path: 'supervisory',
					name: 'supervisory',
					component: ListSupervisory
				},
				{
					path: 'add',
					name: 'add',
					component: Add
				},
				{
					path: 'edit/:id',
					name: 'edit',
					component: Edit,
				},
				{
					path: 'conclusion/:id',
					name: 'conclusion',
					component: Conclusion
				},
				{
					path: 'group_conclusion/:id',
					name: 'group_conclusion',
					component: GroupConclusion
				},
				{
					path: 'warrant/:id',
					name: 'warrant',
					component: Warrant
				},
				{
					path: 'warrant_group',
					name: 'warrant_group',
					component: WarrantGroup
				},
				{
					path: 'reports',
					name: 'reports',
					component: Reports,
					children: [
						{
							path: 'monitoring/',
							component: Monitoring,
							name: 'Monitoring'
						},
						{
							path: 'conclusion/',
							component: ConclusionReport,
							name: 'ConclusionReport'
						},
						{
							path: 'mzl/',
							component: Mzl,
							name: 'Mzl'
						},
						{
							path: 'monitoring-rlh/',
							component: MonitoringRlh,
							name: 'MonitoringRlh'
						},
						{
							path: 'monitoring-v2/',
							component: MonitoringV2,
							name: 'MonitoringV2'
						},
						{
							path: 'conclusion-v2/',
							component: ConclusionReportV2,
							name: 'ConclusionReportV2'
						},
						{
							path: 'mzl-v2/',
							component: MzlV2,
							name: 'MzlV2'
						},
						{
							path: 'monitoring-rlh-v2/',
							component: MonitoringRlhV2,
							name: 'MonitoringRlhV2'
						},
						{
							path: 'npa-mzl/',
							component: NpaMzl,
							name: 'NpaMzl'
						},
						{
							path: 'warrants-count/',
							component: WarrantsCount,
							name: 'WarrantsCount'
						},
						{
							path: 'stat/',
							component: Stat,
							name: 'Stat'
						},
						{
							path: 'stat_lpo/',
							component: StatLpo,
							name: 'StatLpo'
						}
					]
				},
				{
					path: 'reg',
					name: 'reg',
					component: Reg
				},
				{
					path: 'supervision',
					name: 'supervision',
					component: Supervision
				},
				{
					path: 'supervision/:id',
					name: 'supervision',
					component: Supervision
				},
				{
					path: 'catalog',
					name: 'catalog',
					component: TerritoryCatalog
				},
			],
			meta: { requiresAuth: true }
		},
		{
			path: '/login',
			name: 'login',
			component: Login,
			beforeEnter: (to, from, next) => {
				if (!auth.user.authenticated) {
					next()
				}
				else {
					next('/main')
				}
			}
		},
		{
			path: '/*',
			name: 'not-found',
			component: NotFound
		}
	]
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js